// Lib
import React, { ReactElement, memo, useRef } from 'react';

// Utils
import { isLineAffectedByDrag } from '../dragLayerUtil';

// Types
import { LineDragLayerProps } from '../dragTypes';
import { LineDragLayerElement } from './LineDragLayerElement';

const LineDragPerformanceLayer = (props: LineDragLayerProps) => {
    // use a ref to cache the previous render - we don't want useState here, because
    // it'd trigger a re-render when we change it, which would cause an infinite loop!
    const lastRender = useRef<ReactElement | null>(null);

    const { item, itemType, isDropping } = props;

    if (!isLineAffectedByDrag(item, itemType)) return null;

    // Similar to the ElementDragGroupPositioner, this fixes a line blink on drop bug on Chrome.
    // See there for more details.
    if (isDropping) return lastRender.current;

    // The actual rendering happens here
    lastRender.current = <LineDragLayerElement {...props} />;

    return lastRender.current;
};

export default memo(
    LineDragPerformanceLayer,
    (oldProps, newProps) =>
        // return false ("props are *not* equal, so we *should* rerender") if the line is affected
        !(
            isLineAffectedByDrag(newProps.item, newProps.itemType) ||
            isLineAffectedByDrag(oldProps.item, oldProps.itemType)
        ),
);
